/**
 * AuroraBackground — slow-moving blurred gradient orbs in RGU brand colors.
 * Fixed-position, pointer-events: none, sits behind content via z-index: 0.
 * Same approach used by Stripe, Linear, Vercel — premium tech feel, never childish.
 */
export default function AuroraBackground() {
  return (
    <div
      className="rgu-aurora pointer-events-none"
      aria-hidden="true"
      data-testid="aurora-background"
    >
      <div className="rgu-aurora-orb rgu-aurora-orb-1" />
      <div className="rgu-aurora-orb rgu-aurora-orb-2" />
      <div className="rgu-aurora-orb rgu-aurora-orb-3" />
      <div className="rgu-aurora-orb rgu-aurora-orb-4" />
      {/* Fine horizontal scan-line texture overlay (CRT inspired, very subtle) */}
      <div className="rgu-aurora-scanlines" />
      {/* Slow downward scan sweep — single thin beam */}
      <div className="rgu-aurora-sweep" />
    </div>
  );
}
